export default "__VITE_ASSET__Cv05vH0P__"